import React, { FC } from 'react';
import { Redirect } from 'react-router';

import useOnboardingRequirements from 'src/hooks/onboarding/useOnboardingRequirements';

/**
 * Decides whether an onboarding-required user must be redirected.
 */
export const shouldRedirectForOnboarding = ({
  isDevelopmentBuild,
  isOnboardingRequired,
}: {
  isDevelopmentBuild: boolean;
  isOnboardingRequired: boolean;
}): boolean => isOnboardingRequired && !isDevelopmentBuild;

/**
 * Guard that checks if the user has completed the onboarding process.
 * Note: Guards should check only one thing. Don't add any other checks to this Guard.
 *
 * TODO: (Cam) - ENG-14997 - This guard should split into multiple distinct onboarding requirements guards
 */
const RPUserHasFullyOnboardGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isOnboardingRequired: isOnboardingRedirect, onboardingRedirectParams } = useOnboardingRequirements();

  // Development builds can run behind public sandbox hostnames; production remains guarded.
  if (
    shouldRedirectForOnboarding({
      isDevelopmentBuild: import.meta.env.DEV,
      isOnboardingRequired: isOnboardingRedirect,
    })
  ) {
    return <Redirect to={onboardingRedirectParams} />;
  }

  // Don't add components here, please add components either on the app or on the appropriate Layout component
  return <>{children}</>;
};

export default RPUserHasFullyOnboardGuard;
